import { useInfiniteQuery } from 'react-query';
import { QUERY_CACHE_IDS_MAP } from '@types';
import { truktApi } from '@api';

export const useReportsQuery = () => {
  const MAX_ROW_COUNT = 25;
  const MAX_STALE_MINUTES = 5;

  const query = useInfiniteQuery(
    [QUERY_CACHE_IDS_MAP.REPORTS],
    ({ pageParam = 0 }) =>
      truktApi.report.get({
        queryParams: {
          pg: pageParam,
          rc: MAX_ROW_COUNT,
        },
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage.data.results.length === MAX_ROW_COUNT ? pages.length : undefined;
      },

      staleTime: 1000 * 60 * MAX_STALE_MINUTES,
    },
  );

  return query;
};
